import { useEffect, useState } from 'react';

/**
 * Fixed-position banner that appears whenever `navigator.onLine` is false.
 * Mounts once at the app root; listens to window online/offline events.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' && !navigator.onLine
  );

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'var(--color-danger, #cc0000)',
        color: '#fff',
        textAlign: 'center',
        padding: '8px 16px',
        fontSize: 'var(--font-size-sm)',
        fontFamily: 'var(--font-mono)',
      }}
    >
      [offline] you are not connected to the internet. some actions will fail.
    </div>
  );
}
